import {withTranslation} from '../../../i18n';
import css from './PotPromocode.module.scss';
import moment from 'moment';
import Tooltip from "../../widgets/Tooltip/Tooltip";

const namespacesRequired = ['pot', 'common'];

const PotPromocode = ({t, code, customClass}) => {

  if (!code) {
    return null;
  }

  const TooltipContent = () => {
    return (
      <ul className={css.conditions}>
        {code.min_participants_number !== null && (
          <li className={`${css.condition} ${code.has_reached_threshold_participations ? css.success : ''}`}>
            {t('pot:promocode.min-participants', {count: code.min_participants_number})}
          </li>
        )}

        {code.min_collected_amount > 0 && (
          <li className={`${css.condition} ${code.has_reached_threshold_amount ? css.success : ''}`}>
            {t('pot:promocode.min-amount', {amount: (code.min_collected_amount / 100)})}
          </li>
        )}
      </ul>
    );
  };

  const Content = () => {
    if (code.is_eligible) {
      return (
        <div className={css.promocode_desc}>
          <div className={css.status_0}>
            <img src="/static/images/pictos/icon-check-white.svg"/>
          </div>

          {t('pot:promocode.eligible')}
        </div>
      );
    } else if (code.duration_before_reaching_threshold && moment().isAfter(code.date_threshold, "day")) {
      return (
        <div className={css.promocode_desc}>
          <div className={css.status_1}>
            <img src="/static/images/pictos/icon-cross-white.svg"/>
          </div>

          {t('pot:promocode.expired')}
        </div>
      );
    } else {
      return (
        <div className={css.promocode_desc}>
          {t('pot:promocode.desc')}

          {code.date_threshold && (
            <React.Fragment>
              {t('pot:promocode.until', {limitDate: moment(code.date_threshold).format('DD/MM/YYYY')})}
            </React.Fragment>
          )}

          {(code.min_participants_number !== null || code.min_collected_amount !== 0) && (
            <Tooltip>
              <TooltipContent/>
            </Tooltip>
          )}
        </div>
      );
    }
  };
  return (
    <div className={`${customClass ? customClass : ''} ${css.promocode}`}>
      <img src={"/static/images/pictos/icon-gift.svg"} alt="icon cadeau" className={css.picto}/>
      <div>
        <h2 dangerouslySetInnerHTML={{
          __html: t(`pot:promocode.${code.is_eligible ? 'offer_eligible' : 'offer_not_eligible'}`, {
            amount: code.amount / 100,
            reference: code.promo_code_reference
          })
        }}/>
        {Content()}
      </div>
    </div>
  );
};

export default withTranslation(namespacesRequired)(PotPromocode);

